import React from 'react';

import styles from './SectionHeading.module.scss';

export const SectionHeadingWrapper = ({ children }: React.WithChildren) => <div className={styles.headingWrapper}>{children}</div>;
